<template>
    <span class="yushu-image" style="display: inline-block;">
        <i class="iconfont icon-yushulogo" style="font-size: inherit;" v-if="!this.siteInfo || !this.siteInfo.logo || this.siteInfo.logo.length == 0"></i>
        <el-image v-else filt="cover" :src="Utils.getResourceUrl(this.siteInfo.logo)">
            <div slot="error" class="image-slot">
                <img :src="require('@/web-framework/assets/images/course-default.png')">
            </div>
        </el-image>
    </span>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: 'YushuLogo',
    computed: {
        ...mapGetters({
            siteInfo: "siteInfo"
        })
    }
}
</script>
<style lang="less" scoped>
.yushu-image {
    width: 100%;
    height: 100%;
    /deep/.el-image {
        width: 100%;
        height: 100%;
        .image-slot {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>